// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FacultyList.css */

.faculty-list {
    padding: 20px;
    font-family: 'Arial', sans-serif;
    font-size: 12px; /* Smaller font size */
}

h2 {
    font-size: 20px; /* Slightly smaller heading */
    margin-bottom: 20px;
}

.controls {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.search-input {
    padding: 6px; /* Smaller padding */
    font-size: 12px; /* Smaller font size */
    border: 1px solid #ccc;
    border-radius: 4px;
}

button {
    padding: 6px 10px; /* Smaller padding */
    font-size: 12px; /* Smaller font size */
    border: none;
    border-radius: 4px;
    background-color: #9faab6;
    color: white;
    cursor: pointer;
}

button:hover {
    background-color: #0056b3;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

th, td {
    padding: 8px; /* Smaller padding */
    border: 1px solid #ddd;
    text-align: left;
}

th {
    background-color: #f8f9fa;
    cursor: pointer;
}

td {
    background-color: #ffffff;
}

tr:nth-child(even) td {
    background-color: #f2f2f2;
}

.error {
    color: red;
    margin-bottom: 20px;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 400px;
    max-width: 90%;
    text-align: center;
}

.modal-content h2 {
    font-size: 16px; /* Smaller heading */
    margin-bottom: 20px;
}

.modal-content input {
    width: 100%;
    padding: 8px; /* Smaller padding */
    font-size: 8px; /* Smaller font size */
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.modal-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.modal-actions button {
    width: 100px;
    padding: 2px; /* Smaller padding */
    font-size: 10px; /* Smaller font size */
    border-radius: 4px;
}

.modal-actions button:nth-child(1) {
    background-color: #ffffff;
    color: white;
    border: none;
}

.modal-actions button:nth-child(2) {
    background-color: #e2e2e2;
    color: white;
    border: none;
}

.modal-actions button:hover:nth-child(1) {
    background-color: #e2e2e2;
}

.modal-actions button:hover:nth-child(2) {
    background-color: hsl(0, 11%, 96%);
}
`, "",{"version":3,"sources":["webpack://./src/components/FacultyList.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe,EAAE,sBAAsB;AAC3C;;AAEA;IACI,eAAe,EAAE,6BAA6B;IAC9C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,oBAAoB;IAClC,eAAe,EAAE,sBAAsB;IACvC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB,EAAE,oBAAoB;IACvC,eAAe,EAAE,sBAAsB;IACvC,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY,EAAE,oBAAoB;IAClC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe,EAAE,oBAAoB;IACrC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,oBAAoB;IAClC,cAAc,EAAE,sBAAsB;IACtC,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY,EAAE,oBAAoB;IAClC,eAAe,EAAE,sBAAsB;IACvC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["/* FacultyList.css */\r\n\r\n.faculty-list {\r\n    padding: 20px;\r\n    font-family: 'Arial', sans-serif;\r\n    font-size: 12px; /* Smaller font size */\r\n}\r\n\r\nh2 {\r\n    font-size: 20px; /* Slightly smaller heading */\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.controls {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.search-input {\r\n    padding: 6px; /* Smaller padding */\r\n    font-size: 12px; /* Smaller font size */\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\nbutton {\r\n    padding: 6px 10px; /* Smaller padding */\r\n    font-size: 12px; /* Smaller font size */\r\n    border: none;\r\n    border-radius: 4px;\r\n    background-color: #9faab6;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 10px;\r\n}\r\n\r\nth, td {\r\n    padding: 8px; /* Smaller padding */\r\n    border: 1px solid #ddd;\r\n    text-align: left;\r\n}\r\n\r\nth {\r\n    background-color: #f8f9fa;\r\n    cursor: pointer;\r\n}\r\n\r\ntd {\r\n    background-color: #ffffff;\r\n}\r\n\r\ntr:nth-child(even) td {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.error {\r\n    color: red;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.modal-content {\r\n    background-color: white;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    width: 400px;\r\n    max-width: 90%;\r\n    text-align: center;\r\n}\r\n\r\n.modal-content h2 {\r\n    font-size: 16px; /* Smaller heading */\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.modal-content input {\r\n    width: 100%;\r\n    padding: 8px; /* Smaller padding */\r\n    font-size: 8px; /* Smaller font size */\r\n    margin-bottom: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    justify-content: center;\r\n}\r\n\r\n.modal-actions button {\r\n    width: 100px;\r\n    padding: 2px; /* Smaller padding */\r\n    font-size: 10px; /* Smaller font size */\r\n    border-radius: 4px;\r\n}\r\n\r\n.modal-actions button:nth-child(1) {\r\n    background-color: #ffffff;\r\n    color: white;\r\n    border: none;\r\n}\r\n\r\n.modal-actions button:nth-child(2) {\r\n    background-color: #e2e2e2;\r\n    color: white;\r\n    border: none;\r\n}\r\n\r\n.modal-actions button:hover:nth-child(1) {\r\n    background-color: #e2e2e2;\r\n}\r\n\r\n.modal-actions button:hover:nth-child(2) {\r\n    background-color: hsl(0, 11%, 96%);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
